import React, { useState } from 'react';
import { Provider, useSelector } from 'react-redux';
import store from '../../redux/store';

import { travelerLogin } from '../../service/travelerLoginService';
import { hasValidationErrors } from '../../lib/airframe/FormValidation';

import { CiriumWrapper } from '../../components/cirium/CiriumWrapper';
import { TravelerLoginCard } from './TravelerLoginCard';

import { selectImageUrl } from '../../redux/entities/brandingImage/brandingImageSelectors';
import { goTo } from '../../configTdm';

interface LoginValues {
  username: string;
  password: string;
  kwijybo: string;
}

interface ErrorResponse {
  message: string;
}

const TravelerLoginContainer: React.FC = () => {
  const [formDisabled, setFormDisabled] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const brandingImageUrl = useSelector(selectImageUrl);

  const travelerLoginInfo = (values: LoginValues) => ({
    username: values.username,
    password: values.password,
    kwijybo: values.kwijybo,
  });

  const handleLoginError = (response: ErrorResponse) => {
    const message = response.message || '';
    const isAuthError =
      message.toLowerCase().includes('invalid user') ||
      message.toLowerCase().includes('unauthorized');
    if (isAuthError) {
      setErrorMessage('Invalid Credentials');
    } else {
      const cleanMessage = message.includes(': ')
        ? message.slice(message.indexOf(': ') + 2)
        : message;
      setErrorMessage(cleanMessage || 'Log in is temporarily unavailable');
    }
  };

  const handleLogin = (errors: any, values: LoginValues) => {
    if (!hasValidationErrors(errors)) {
      setFormDisabled(true);
      setErrorMessage('');
      travelerLogin(travelerLoginInfo(values))
        .then(response => {
          goTo(response.redirectPath);
        })
        .catch(error => {
          handleLoginError(error);
        })
        .finally(() => setFormDisabled(false));
    }
  };

  return (
    <CiriumWrapper loading={formDisabled}>
      <TravelerLoginCard
        handleLogin={handleLogin}
        loading={formDisabled}
        errorMessage={errorMessage}
        brandingImageUrl={brandingImageUrl}
      />
    </CiriumWrapper>
  );
};

const WrappedTravelerLoginContainer: React.FC = () => (
  <Provider store={store}>
    <TravelerLoginContainer />
  </Provider>
);

export default WrappedTravelerLoginContainer;